import axios from 'axios';

const BASE = '/api/v2/internal/search_scrape';

// Synchronous run for small manual batches. Returns { results: [...] }.
export async function runSync(rows, options) {
  const res = await axios.post(BASE, { rows, options });
  return res.data;
}

// Enqueues an async batch (CSV). Returns { batch_id, total }.
export async function runBatch(rows, options) {
  const res = await axios.post(`${BASE}/batch`, { rows, options });
  return res.data;
}

// Polls async batch progress/results.
export async function fetchBatchStatus(batchId, signal) {
  const res = await axios.get(`${BASE}/status`, { params: { batch_id: batchId }, signal });
  return res.data;
}

// Live query preview (no external API calls).
export async function previewQueries(rows) {
  const res = await axios.post(`${BASE}/preview`, { rows });
  return res.data;
}
